export const mutations = {
  STORE_PURCHASESRECEIVING_PURCHASES(state, purchase_receiving_item) {
    state.purchase_receiving_item = purchase_receiving_item;
  },

  STORE_PURCHASES(state, purchases) {
    state.purchases = purchases;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/purchases/mutations.js